// source: PrivateAccountV3Api.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

goog.exportSymbol('proto.PrivateAccountV3Api', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.PrivateAccountV3Api = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.PrivateAccountV3Api, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.PrivateAccountV3Api.displayName = 'proto.PrivateAccountV3Api';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.PrivateAccountV3Api.prototype.toObject = function(opt_includeInstance) {
  return proto.PrivateAccountV3Api.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.PrivateAccountV3Api} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PrivateAccountV3Api.toObject = function(includeInstance, msg) {
  var f, obj = {
vcoinname: jspb.Message.getFieldWithDefault(msg, 1, ""),
coinid: jspb.Message.getFieldWithDefault(msg, 2, ""),
balanceamount: jspb.Message.getFieldWithDefault(msg, 3, ""),
balanceamountchange: jspb.Message.getFieldWithDefault(msg, 4, ""),
frozenamount: jspb.Message.getFieldWithDefault(msg, 5, ""),
frozenamountchange: jspb.Message.getFieldWithDefault(msg, 6, ""),
type: jspb.Message.getFieldWithDefault(msg, 7, ""),
time: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.PrivateAccountV3Api}
 */
proto.PrivateAccountV3Api.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.PrivateAccountV3Api;
  return proto.PrivateAccountV3Api.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.PrivateAccountV3Api} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.PrivateAccountV3Api}
 */
proto.PrivateAccountV3Api.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setVcoinname(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setCoinid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setBalanceamount(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setBalanceamountchange(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setFrozenamount(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setFrozenamountchange(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setType(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.PrivateAccountV3Api.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.PrivateAccountV3Api.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.PrivateAccountV3Api} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PrivateAccountV3Api.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVcoinname();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCoinid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getBalanceamount();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getBalanceamountchange();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getFrozenamount();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getFrozenamountchange();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getTime();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
};


/**
 * optional string vcoinName = 1;
 * @return {string}
 */
proto.PrivateAccountV3Api.prototype.getVcoinname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.PrivateAccountV3Api} returns this
 */
proto.PrivateAccountV3Api.prototype.setVcoinname = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string coinId = 2;
 * @return {string}
 */
proto.PrivateAccountV3Api.prototype.getCoinid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.PrivateAccountV3Api} returns this
 */
proto.PrivateAccountV3Api.prototype.setCoinid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string balanceAmount = 3;
 * @return {string}
 */
proto.PrivateAccountV3Api.prototype.getBalanceamount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.PrivateAccountV3Api} returns this
 */
proto.PrivateAccountV3Api.prototype.setBalanceamount = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string balanceAmountChange = 4;
 * @return {string}
 */
proto.PrivateAccountV3Api.prototype.getBalanceamountchange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.PrivateAccountV3Api} returns this
 */
proto.PrivateAccountV3Api.prototype.setBalanceamountchange = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string frozenAmount = 5;
 * @return {string}
 */
proto.PrivateAccountV3Api.prototype.getFrozenamount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.PrivateAccountV3Api} returns this
 */
proto.PrivateAccountV3Api.prototype.setFrozenamount = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string frozenAmountChange = 6;
 * @return {string}
 */
proto.PrivateAccountV3Api.prototype.getFrozenamountchange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.PrivateAccountV3Api} returns this
 */
proto.PrivateAccountV3Api.prototype.setFrozenamountchange = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string type = 7;
 * @return {string}
 */
proto.PrivateAccountV3Api.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.PrivateAccountV3Api} returns this
 */
proto.PrivateAccountV3Api.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional int64 time = 8;
 * @return {number}
 */
proto.PrivateAccountV3Api.prototype.getTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.PrivateAccountV3Api} returns this
 */
proto.PrivateAccountV3Api.prototype.setTime = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


goog.object.extend(exports, proto);
